export const ERR_OUTLET_HAS_PENDING_CHANGE_REQUEST = "ERR_OUTLET_HAS_PENDING_CHANGE_REQUEST";

type ApiErrorLike = {
  response?: { status?: number; data?: { code?: string; message?: string } };
  message?: string;
};

export const getApiErrorCode = (error: unknown): string | undefined =>
  (error as ApiErrorLike)?.response?.data?.code;

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const e = error as ApiErrorLike;
  return e?.response?.data?.message || fallback;
};
